import React from "react";
import Routes from "./Routes";
import GoogleAnalytics from "./components/GoogleAnalytics";

function App() {
  return (
    <>
      {/* Add your Google Analytics Tracker */}
      <GoogleAnalytics measurementId="G-46R0B4HTSG" />
      <Routes />
    </>
  );
}

export default App;
